<template>
  <div class="header">
    <div class="icon-back" @click="router.push('/analytics')">
      <LeftOutlined class="icon-arrow"/>
    </div>
    <p class="header-text">Эталонный профиль</p>
  </div>

  <div class="card report-options flex flex-column align-item-start">
    <p>
      Определяет, какие параметры ЭИ связаны с высоким достижением KPI на конкретной должности, и формирует эталон компетенций на основе данных минимум 60 сотрудников. Позволяет сравнивать результаты сотрудников с эталоном и классифицировать их по уровню соответствия.
    </p>
    <div class="report-options__body">
      <div>
        <span class="label">
          Группа
        </span>
        <a-select
            v-model:value="group"
            :placeholder="'Выберите группу'"
            style="width: 100%;"
            :not-found-content="'Нет данных'"
            show-arrow
        >
          <a-select-option v-for="item in groupOptions" :key="item.id" :value="item.id">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </div>

      <div>
        <span class="label">
          Эталонный профиль
        </span>
        <a-select
            v-model:value="currentReference"
            :placeholder="'Выберите профиль'"
            style="width: 100%;"
            :not-found-content="'Нет данных'"
            show-arrow
        >
          <a-select-option v-for="item in referenceOptions" :key="item.id" :value="item.id">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div
      v-if="group !== null && currentReference"
      class="report-options__btn flex justify-content-center"
    >
      <a-button @click="requestForReport" class="primary-button">
        Сформировать отчет
      </a-button>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref } from "@vue/runtime-core";
import CustomSelect2 from "../../../components/Forms/Fields/CustomSelect2.vue";
import { useStore } from "vuex";
import {useRoute} from "vue-router";
import {LeftOutlined} from "@ant-design/icons-vue";
import {useRouter} from "vue-router";

export default {
  components: {LeftOutlined, CustomSelect2 },
  name: "reference-users-report-parametres",
  setup(props, context) {
    const store = useStore(),
    route = useRoute()
    const group = ref(null),
      groupOptions = ref([]),
      referenceOptions = ref([]);
    const selectedGroup = computed(() => store.state.analytics.selectedGroup),
      groups = computed(() => store.state.group.groups),
      referenceProfiles = computed(
        () => store.state.analytics.referenceProfiles
      ),
      expertReferenceProfiles = computed(
        () => store.state.analytics.expertReferenceProfiles
      ),
        currentReference = ref(null);

    const router = useRouter();


    onBeforeMount(() => {
      store.dispatch("group/getGroups").then(() => {
        groupOptions.value.push({ id: 0, text: "Все сотрудники"});
        groupOptions.value = groupOptions.value.concat(groups.value.map((group) => {
          return { id: group.id, text: group.name };
        }));
      });
      store.dispatch("analytics/getReferenceProfiles").then(() => {
        referenceProfiles.value.forEach((reference) => {
          referenceOptions.value.push({
            id: reference.id,
            text: reference.title,
          });
        });
        currentReference.value = referenceProfiles.value.find((reference) => reference.id == route.query?.id).id.toString()
      });
    });

    const requestForReport = () => {
      store.dispatch('group/clearAnalyticsGroupData');
      let currentGroup;

      if (selectedGroup.value !== 0) {
        currentGroup = groups.value.find((el) => el.id === group.value);
      }

      store.dispatch('group/setAnalyticsGroupData', {
        group_1: {
          name: currentGroup?.name ?? 'Все сотрудники',
          count: currentGroup?.users_count ?? null,
        },
        group_2: null,
      });

      context.emit("reportRequest", {
        group_id: group.value,
        reference_profile_id: currentReference.value,
      });
    };

    return {
      group,
      groupOptions,
      selectedGroup,
      groups,
      requestForReport,
      referenceOptions,
      currentReference,
      router
    };
  },
};
</script>
